import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { successOpen, updateUser } from '@app-modules/feature/editprofile/editprofile.component';
import { BoardsService } from '@app-services/boarrds/boards.service';
import { UserService } from '@app-services/user/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExamDialogComponent } from '../exam-dialog/exam-dialog.component';
import { GradesdialogComponent } from '../gradesdialog/gradesdialog.component';

@Component({
  selector: 'app-boards-dialog',
  templateUrl: './boards-dialog.component.html',
  styleUrls: ['./boards-dialog.component.css']
})
export class BoardsDialogComponent implements OnInit {
  boardForm: any;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  searchText = '';
  boards:any = [];
  searchIndices: any = [];
  allSearchIndices: any = [];
  index: any;

  constructor(private _formBuilder: FormBuilder, private dialogRef: MatDialogRef<BoardsDialogComponent>,
    private dialog: MatDialog, private boardsServices: BoardsService,
    private spinner: NgxSpinnerService, 
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      dialogRef.disableClose = !this.data.isBoardEdit;
  }

  ngOnInit(): void {
    console.log('dialog data', this.data);
    this.getBoards();
  }

  getBoards(): any {
    this.boardsServices.fetchBoardsList().subscribe((data: any) => {
      this.boards = data;
      for(let i =0, len = data.length; i < len; i++ ) {
        this.searchIndices.push(i);
      }
      this.allSearchIndices = this.searchIndices;

      if (this.data.board) {
        for(let i =0, len = data.length; i< len; i++ ) 
        {
          if(data[i].boardId == this.data.board.boardId) {
            this.index = i;
            break;
          }
        }
      }
    });
  }

  saveIndex(i: any) {
    this.index = i;
    if(!this.data?.isBoardEdit) {
      this.selectBoard(i);
    }
  }

  onConfirmClick() {
    if (this.data.isBoardEdit) {

      if(this.index !=undefined || this.index !=null) {
        updateUser.call(this, [{name: 'board', value: this.boards[this.index]}], () => {
          successOpen.call(this, 'Profile Updated' ,`Your board information has been updated  successfully`, () => this.dialogRef.close(this.boards[this.index]));
        })
      } 
    }
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  selectBoard(i: any) {
    this.dialogRef.close();
    const config: MatDialogConfig = {
      maxWidth:"570px",
      //height: '100%',
      panelClass:'mat-full',
      data: {
        message: 'What exams are you targeting?', message2: `Select as many. If you can’t find it in the list, enter in the search box`,
        accountDetails: this.data.accountDetails, grade: this.data.grade,
        selectedStream:this.data.selectedStream,
        board: this.boards[i],
        actionData: this.data?.actionData
      }
    };
    const dialogRef = this.dialog.open(ExamDialogComponent, config);
  }

  searchBoards(event: KeyboardEvent) { // with type info
    const searchString = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if(searchString == "") {
      this.searchIndices = this.allSearchIndices
    } else {
      const res: any = [];
      const boards = this.boards;
      for(let i = 0, len = boards.length; i < len; i++) {
        if(boards[i].name.toLowerCase().indexOf(searchString) >  -1 || boards[i].description.toLowerCase().indexOf(searchString) > -1) {
          res.push(i);
        }
      }
      this.searchIndices = res;
    }
  }
  showPrevStep() {
    this.dialogRef.close();
    const config: MatDialogConfig = {
      maxWidth:"570px",
      //height: '100%',
      panelClass:'mat-full',
      data: {
        message:'Great, your account is almost ready',
        message2: 'Help us with your academic details, so we can curate content specially for you',
        accountDetails: this.data.accountDetails,
        grade: this.data.grade,
        selectedStream:this.data.selectedStream,
        actionData: this.data?.actionData
      }
    };
    const dialogRef = this.dialog.open(GradesdialogComponent, config);
  }
}
